import React, { FC } from 'react';
import Controls from './Controls';
import { TitleContainer } from './Keypointer.style';
import Labels from './Labels';

interface IProps {
  dicom: any;
  activeFrame: any;
  activeFrameIndex: any;
  activeKeypoints: any;
  setActiveFrameIndex: any;
  phaseLabels: any;
  keypointCollectionClasses: any;
  activeKeypointCollectionClass: any;
  setActiveKeypointCollectionClass: any;
  showMeasurements: any;
  showPhaser: any;
  setShowMeasurements: any;
  keypointCollectionLabels: any;
  setKeypoints: any;
}

const Keypointer: FC<IProps> = props => {
  const {
    dicom,
    activeFrame,
    activeFrameIndex,
    activeKeypoints,
    setActiveFrameIndex,
    phaseLabels,
    keypointCollectionClasses,
    activeKeypointCollectionClass,
    setActiveKeypointCollectionClass,
    showMeasurements,
    showPhaser,
    setShowMeasurements,
    keypointCollectionLabels,
    setKeypoints,
  } = props;
  return (
    <div>
      <TitleContainer>Label Keypoints</TitleContainer>
      <Labels
        dicom={dicom}
        setKeypoints={setKeypoints}
        activeKeypoints={activeKeypoints}
        activeFrameIndex={activeFrameIndex}
        activeFrame={activeFrame}
        setActiveFrameIndex={setActiveFrameIndex}
        phaseLabels={phaseLabels}
        keypointCollectionClasses={keypointCollectionClasses}
        activeKeypointCollectionClass={activeKeypointCollectionClass}
        setActiveKeypointCollectionClass={setActiveKeypointCollectionClass}
        keypointCollectionLabels={keypointCollectionLabels}
        showPhaser={showPhaser}
      />
      <Controls
        showMeasurements={showMeasurements}
        setShowMeasurements={setShowMeasurements}
        setKeypoints={setKeypoints}
        activeKeypoints={activeKeypoints}
      />
    </div>
  );
};

export default Keypointer;
